'use strict';

import template from './conversation_trip_avatar.html';

export default {
  template: template,
  bindings: {
    avatars: '<',
  },
  controller: function(imgixHelpers) {
    'ngInject';

    const STARTING_POSITION = -20;
    const INCREMENT_OVERLAP = 20;
    const Z_INDEX = 100;
    var shift = STARTING_POSITION;
    var z_index = Z_INDEX;

    this.avatars.forEach((avatar) => {
      shift = shift + INCREMENT_OVERLAP;
      z_index = z_index - 1;
      avatar.shift = shift + 'px';
      avatar.z_index = z_index;
      var url = imgixHelpers.getUrl(avatar, {w: 32, h: 32}, imgixHelpers.getCropCoords(avatar.crop));
      avatar.path = `white url('${url}')`;
    });

    // One avatar takes up 32px, any additional avatars take up 20px
    const ONE_AVATAR = 32;
    const OTHER_AVATARS = 20;
    const FIRST_AVATAR = 1;
    this.avatarWidth = ONE_AVATAR + OTHER_AVATARS * (this.avatars.length - FIRST_AVATAR) + 'px';
  },
};



// WEBPACK FOOTER //
// ./app/src/components/conversations_trips/conversation_trip_avatar/conversation_trip_avatar.js